
import type { CreateParams, SaleType } from 'app/dataTypes/dishes/saleType'
import type { Request } from '../../../index'


type ApiParams = {
  title: string
}

export const convertParams = ({ title }: CreateParams): [ApiParams, null] => {
  return [{ title }, null]
}

type ApiResult = { id: number, title: string, reserved: boolean }

export const convertResult = (data: ApiResult): SaleType => {
  const { id, title, reserved } = data
  return {
    id: String(id),
    title,
    reserved,
  }
}

export const POST_SALE_TYPE: Request<
  CreateParams,
  SaleType,
  null
> = [
  'food/items/sale_types',
  'post',
  ['data', 'sale_types'],
]
